import React, { useState } from "react";

export const SubmenuControls = ({data, selectedItem, onSelectedItem}) => {
    return (
        <div className="submenu-container"> 
            {data &&
                <>
                    <h1>{data.label}</h1>
                    <nav>
                        <ul role="menu" aria-label="secondaire">
                            {data.items.map((i, index) => 
                                <li role="menuitem" key={`item-${index}`} className={selectedItem.id == i.id ? 'active': ''} onClick={() => onSelectedItem(i.id)}>{i.label}</li>)
                            }
                        </ul>
                    </nav>
                </>
            }
        </div>
    )
}